module.exports = __webpack_public_path__ + "static/media/refresh.a5ebda70.svg";